export enum UserAccessLevelType {
    GlobalAdministrator = 1,
    DealershipAdministrator,
    DealershipUser,
    CustomerAdministrator,
    CustomerUser
}

export class User {
    public Id: number;
    public Name: string;
    public Email: string;
    public AccessLevel: UserAccessLevelType;
}

export class JobRole {
    public Id: number;
    public Name: string;
}